import Vue from 'vue';
import STAFF from '../../../api/staff';
import legalType from '../../constants-v2/person/legal-type.js';

const getBaseStaff = () => {
  return {
    employee: {
      person: getBasePerson(),
    },
    roles: [],
    additionalIncomes: [],
  };
};

const baseDocument = {
  document_type: '',
  document_number: '',
  release_date: '',
  expiration_date: '',
};

const getBasePersonAddress = () => {
  return {
    residence_address: {},
    registered_address: {},
    correspondence_address: {},
    company_address: {},
  };
};
const getBaseCompany = () => {
  return {
    name: '',
    surname: '',
    nip: '',
    nip_ue: '',
    regon: '',
    phone: '',
    email: '',
    tax_office: '',
    official_bank_account: '',
    is_foreign_company: false,
    country_code: '',
  };
};
const getBasePerson = () => {
  return {
    name: '',
    second_name: '',
    surname: '',
    family_name: '',
    phone: '',
    phone_private: '',
    email: '',
    login_email: '',
    correspondence_email: '',
    email_private: '',
    citizenship: '',
    pesel: '',
    nip: '',
    fathers_name: '',
    mothers_name: '',
    birth_date: null,
    gender: null,
    legaltype: legalType.INDIVIDUAL,
    personaddress: getBasePersonAddress(),
    company: getBaseCompany(),
    bankaccounts: [],
    personstatustype: {},
    personbankaccount: {
      main_bank_account: {},
    },
    identification_type: null,
  };
};

const state = {
  //employee personal data
  refresh: false,
  staff: getBaseStaff(),
  payrolls: [],
  citizenships: [
    { value: 1, label: 'Polskie' },
    { value: 2, label: 'Czeskie' },
  ],
  identification_types: [
    { value: 1, label: 'Dowód osobisty' },
    { value: 2, label: 'Paszport' },
    { value: 3, label: 'Wiza' },
  ],

  //documents
  document: { ...baseDocument },
  document_types: [
    { value: 1, label: 'Dokument1' },
    { value: 2, label: 'Dokument2' },
    { value: 3, label: 'Dokument3' },
  ],
  documents: [
    { id: 1, value: 1, expiration_date: '03-01-2020', label: 'Dokument1' },
    { id: 2, value: 2, expiration_date: '03-01-2020', label: 'Dokument2' },
    { id: 3, value: 3, expiration_date: '03-01-2020', label: 'Dokument3' },
  ],

  bill: {},
  billGeneratorData: [],
};

const getters = {
  getCorrespondenceAddress: state => {
    return state.staff.employee.person.personaddress.correspondence_address;
  },
  getRegisteredAddress: state => {
    return state.staff.employee.person.personaddress.registered_address;
  },
  getResidenceAddress: state => {
    return state.staff.employee.person.personaddress.residence_address;
  },
  getCompanyAddress: state => {
    return state.staff.employee.person.personaddress.company_address;
  },
  getPersonId: state => {
    return state.staff.employee.person.id;
  },
  getBankAccounts: state => {
    return state.staff.employee.person.bankaccounts;
  },
  getDefaultAccount: state => {
    if (state.staff.employee.person.personbankaccount && state.staff.employee.person.personbankaccount.main_bank_account && state.staff.employee.person.personbankaccount.main_bank_account.id) {
      return state.staff.employee.person.personbankaccount.main_bank_account;
    }
    return {};
  },
  getAdditionalIncomes: state => {
    return state.staff.additionalIncomes || [];
  },
  getAdditionalIncomesForBackend: state => {
    // Return additional incomes without tempId for backend requests
    return (state.staff.additionalIncomes || []).map(income => {
      const { tempId, ...cleanIncome } = income;
      return cleanIncome;
    });
  },
};

const actions = {
  showStaff({ commit, dispatch, state }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      STAFF.showStaff(id).then(response => {
        commit('setStaff', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  storeStaff({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      STAFF.store(state.staff).then(response => {
        commit('storeStaff', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  updateStaff({ commit, dispatch, state }, staffData = null) {
    commit('LOADER/setLoading', true, { root: true });
    const requestStaff = (staffData === null || staffData === undefined) ? state.staff : staffData;
    return new Promise((resolve, reject) => {
      STAFF.update(requestStaff).then(response => {
        // commit('setStaff', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  getVersions({ commit }, original) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      STAFF.getVersions(original).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  updateResidenceAddress({ commit }, residence_address) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      commit('setResidenceAddress', residence_address);
      setTimeout(function () {
        commit('LOADER/setLoading', false, { root: true });
        resolve();
      }, 1000);
    });
  },
  updateRegisteredAddress({ commit }, registered_address) {
    commit('LOADER/setLoading', true, { root: true });
    commit('setRegisteredAddress', registered_address);
    setTimeout(function () {
      commit('LOADER/setLoading', false, { root: true });
    }, 1000);
  },
  updateCorrespondenceAddress({ commit }, correspondence_address) {
    commit('LOADER/setLoading', true, { root: true });
    commit('setCorrespondenceAddress', correspondence_address);
    setTimeout(function () {
      commit('LOADER/setLoading', false, { root: true });
    }, 1000);
  },
  // ------------------------------------------------------------------------
  //PAYROLLS
  indexPayrolls({ commit, dispatch, state }, url) {
    return new Promise((resolve, reject) => {
      STAFF.PAYROLL.index(url).then(response => {
        commit('setPayrolls', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  generateIndividualPaymentList({ commit, dispatch, state }, agreementId) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      STAFF.PAYROLL.generateIndividualPaymentList(agreementId).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  destroyPayroll({ commit, dispatch, state }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      STAFF.PAYROLL.destroy(id).then(response => {
        dispatch('indexPayrolls');
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  // ------------------------------------------------------------------------
  //BILLS
  indexBills({ commit, dispatch, state }, url) {
    return new Promise((resolve, reject) => {
      STAFF.BILL.index(url).then(response => {
        commit('setBills', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  generateBill({ commit, dispatch, state }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      STAFF.BILL.generateBill(payload).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  prepareGeneratorData({ commit, dispatch, state }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    commit('setBillGeneratorData', []);
    return new Promise((resolve, reject) => {
      STAFF.BILL.prepareGeneratorData(payload).then(response => {
        commit('setBillGeneratorData', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  clearBillGeneratorData({ commit }) {
    commit('clearBillGeneratorData');
  },
  // ------------------------------------------------------------------------
  //DOCUMENTS
  storeDocument({ commit, dispatch, state }) {
    console.log('storeDocument');
    // commit('LOADER/setLoading', true, {root: true});
    // return new Promise((resolve, reject) => {
    //     STAFF.storeDocument().then(response => {
    commit('clearDocument');
    //         dispatch('indexDocuments');
    //         resolve(response);
    //     }).catch(error => {
    //         reject(error);
    //     }).finally(function () {
    //         commit('LOADER/setLoading', false, {root: true});
    //     })
    // });
    // commit('storeDocument', state.document);
  },
  updateDocument({ commit, dispatch, state }, id) {
    console.log('updateDocument');
    // commit('LOADER/setLoading', true, {root: true});
    // return new Promise((resolve, reject) => {
    //     STAFF.updateDocument(id).then(response => {
    commit('clearDocument');
    //         dispatch('indexDocuments');
    //         resolve(response);
    //     }).catch(error => {
    //         reject(error);
    //     }).finally(function () {
    //         commit('LOADER/setLoading', false, {root: true});
    //     })
    // });
    // commit('storeDocument', state.document);
  },
  destroyDocument({ commit, dispatch, state }, id) {
    console.log('destroyDocument');
    // commit('LOADER/setLoading', true, {root: true});
    // return new Promise((resolve, reject) => {
    //     STAFF.destroyDocument(id).then(response => {
    //         dispatch('indexDocuments');
    //         resolve(response);
    //     }).catch(error => {
    //         reject(error);
    //     }).finally(function () {
    //         commit('LOADER/setLoading', false, {root: true});
    //     })
    // });
    // commit('storeDocument', state.document);
  },

  clearDocument({ commit }) {
    commit('clearDocument');
  },
  clearStaff({ commit }) {
    commit('clearStaff');
  },
  clearAddresses({ commit }) {
    commit('setResidenceAddress', getBasePerson().personaddress.residence_address);
    commit('setRegisteredAddress', getBasePerson().personaddress.registered_address);
    commit('setCorrespondenceAddress', getBasePerson().personaddress.correspondence_address);
  },
  refresh({ commit }, payload) {
    commit('refresh', payload);
  },
  setPersonStatus({ commit }, status) {
    commit('setPersonStatus', status);
  },
};

const mutations = {
  assignStaffObject(state, staffObject) {
    state.staff = { ...staffObject };
  },
  updatePerson(state, { key, value }) {
    state.staff.employee.person[key] = value;
  },
  setStaff(state, staff) {
    state.staff = staff;
    state.staff.employee.person.create_account = false;
  },
  storeStaff(state, staff) {
    state.employee = staff.employee;
  },
  updateStaff(state, staff) {
    state.employee = staff.employee;
  },
  setEmployeeName(state, name) {
    state.staff.employee.person.name = name;
  },
  setSecondName(state, secondName) {
    state.staff.employee.person.second_name = secondName;
  },
  setSurname(state, surname) {
    state.staff.employee.person.surname = surname;
  },
  setFamilyName(state, familyName) {
    state.staff.employee.person.family_name = familyName;
  },
  setPhone(state, phone) {
    state.staff.employee.person.phone = phone;
  },
  setPhonePrivate(state, phone) {
    state.staff.employee.person.phone_private = phone;
  },
  setEmail(state, email) {
    state.staff.employee.person.email = email;
  },
  setLoginEmail(state, email) {
    state.staff.employee.person.login_email = email;
  },
  setCorrespondenceEmail(state, email) {
    state.staff.employee.person.correspondence_email = email;
  },
  setEmailPrivate(state, email) {
    state.staff.employee.person.email_private = email;
  },
  setCitizenship(state, citizenship) {
    state.staff.employee.person.citizenship = citizenship;
  },
  setIdentificationType(state, identification_type) {
    state.staff.employee.person.identification_type = identification_type;
  },
  setIdentificationSeries(state, identification_series) {
    state.staff.employee.person = {
      ...state.staff.employee.person,
      identification_series: identification_series,
    };
  },
  setIdentificationNumber(state, identification_number) {
    state.staff.employee.person = {
      ...state.staff.employee.person,
      identification_number: identification_number,
    };
  },
  setIdentificationIssuePlace(state, identification_issue_place) {
    state.staff.employee.person = {
      ...state.staff.employee.person,
      identification_issue_place: identification_issue_place,
    };
  },
  setIdentificationIssueBy(state, identification_issue_by) {
    state.staff.employee.person = {
      ...state.staff.employee.person,
      identification_issue_by: identification_issue_by,
    };
  },
  setIdentificationIssueDate(state, identification_issue_date) {
    state.staff.employee.person.identification_issue_date = identification_issue_date;
  },
  setIdentificationExpirationDate(state, identification_expiration_date) {
    state.staff.employee.person.identification_expiration_date = identification_expiration_date;
  },
  setFathersName(state, fathers_name) {
    state.staff.employee.person.fathers_name = fathers_name;
  },
  setMothersName(state, mothers_name) {
    state.staff.employee.person.mothers_name = mothers_name;
  },
  setPersonNip(state, nip) {
    state.staff.employee.person.nip = nip;
  },
  setPesel(state, pesel) {
    state.staff.employee.person.pesel = pesel;
  },
  setBirthDate(state, birthDate) {
    state.staff.employee.person.birth_date = birthDate;
  },
  setGender(state, gender) {
    state.staff.employee.person.gender = gender;
  },

  //PAYROLLS
  setPayrolls(state, payrolls) {
    state.payrolls = payrolls;
  },

  //BILLS
  setBills(state, bills) {
    state.bills = bills;
  },
  setBillGeneratorData(state, data) {
    let preparedData = JSON.parse(JSON.stringify(data));
    for (let i in preparedData) {
      preparedData[i].isActive = true;
      preparedData[i].duplicate = false;
    }
    state.billGeneratorData = preparedData;
  },
  setBillGeneratorDataByIndex(state, payload) {
    Vue.set(state.billGeneratorData, payload.index, JSON.parse(JSON.stringify(payload.data)));
  },
  duplicateGeneratorData(state, payload) {
    state.billGeneratorData.push({ ...payload.data });
  },

  clearBillGeneratorData(state) {
    state.billGeneratorData = [];
  },

  //DOCUMENT
  setDocumentType(state, type) {
    state.document.document_type = type;
  },
  setDocumentNumber(state, number) {
    state.document.document_number = number;
  },
  setReleaseDate(state, date) {
    state.document.release_date = date;
  },
  setExpirationDate(state, date) {
    state.document.expiration_date = date;
  },
  clearDocument(state) {
    state.document = { ...baseDocument };
  },
  clearStaff(state) {
    state.staff = getBaseStaff();
    state.staff.additionalIncomes = [];
  },
  setResidenceAddress(state, residence_address) {
    state.staff.employee.person.personaddress.residence_address = residence_address;
  },
  setRegisteredAddress(state, registered_address) {
    state.staff.employee.person.personaddress.registered_address = registered_address;
  },
  setCorrespondenceAddress(state, correspondence_address) {
    state.staff.employee.person.personaddress.correspondence_address = correspondence_address;
  },
  setCompanyAddress(state, company_address) {
    state.staff.employee.person.personaddress.company_address = company_address;
  },

  // COMPANY
  setCompanyPhone(state, phone) {
    state.staff.employee.person.company.phone = phone;
  },
  setIsForeignCompany(state, is_foreign_company) {
    state.staff.employee.person.company.is_foreign_company = is_foreign_company;
  },
  setCountryCode(state, country_code) {
    state.staff.employee.person.company.country_code = country_code;
  },
  setCompanyEmail(state, email) {
    state.staff.employee.person.company.email = email;
  },
  setCompanyName(state, name) {
    state.staff.employee.person.company.name = name;
  },
  setNip(state, nip) {
    state.staff.employee.person.company.nip = nip;
  },
  setNipUE(state, nip_ue) {
    state.staff.employee.person.company.nip_ue = nip_ue;
  },
  setRegon(state, regon) {
    state.staff.employee.person.company.regon = regon;
  },
  setRoles(state, roles) {
    state.staff.roles = roles;
  },

  // BANK ACCOUNTS
  addCompanyBankAccount(state, account) {
    state.staff.employee.person.bankaccounts.push(account);
  },
  setDefaultAccount(state, account) {
    if (!state.staff.employee.person.personbankaccount) {
      state.staff.employee.person.personbankaccount = {
        id: 0,
      };
    }
    state.staff.employee.person.personbankaccount.main_bank_account = account;
  },
  refresh(state, payload) {
    state.refresh = payload;
  },
  //Options
  setPersonStatus(state, status) {
    state.staff.employee.person.personstatustype = status;
  },
  setCompanyOfficialBankAccount(state, official_bank_account) {
    state.staff.employee.person.company.official_bank_account = official_bank_account;
  },
  setCompanyTaxOffice(state, tax_office) {
    state.staff.employee.person.company.tax_office = tax_office;
  },
  // Additional Income mutations
  setAdditionalIncomes(state, additionalIncomes) {
    state.staff.additionalIncomes = additionalIncomes || [];
  },
  addAdditionalIncome(state, income) {
    if (!state.staff.additionalIncomes) {
      state.staff.additionalIncomes = [];
    }
    state.staff.additionalIncomes.push({
      ...income,
      tempId: Date.now(), // Temporary ID for local management, not sent to backend
    });
  },
  updateAdditionalIncome(state, { index, income }) {
    if (state.staff.additionalIncomes && state.staff.additionalIncomes[index]) {
      const existingItem = state.staff.additionalIncomes[index];
      // Preserve tempId for local items, id for API items
      const preservedId = existingItem.tempId ? { tempId: existingItem.tempId } :
        existingItem.id ? { id: existingItem.id, original: existingItem.original } : {};

      const updatedItem = {
        ...income,
        ...preservedId,
      };

      // Use Vue.set for proper reactivity
      Vue.set(state.staff.additionalIncomes, index, updatedItem);
    }
  },
  deleteAdditionalIncome(state, index) {
    if (state.staff.additionalIncomes && state.staff.additionalIncomes[index] !== undefined) {
      state.staff.additionalIncomes.splice(index, 1);
    }
  },
  clearAdditionalIncomes(state) {
    state.staff.additionalIncomes = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
